// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3FnvC","footer":"ReportModalFilter_footer__2wq5d"};